export default __webpack_public_path__ + "images/Tapclicks.44d709513f2ade0de17aa5ab60e11cd4.svg";